import { useState } from 'react';
import Hero from './Hero';
import clsx from 'clsx';
import { useBrandContext } from 'context/BrandProvider';
import AbstractBackground from './AbstractBackground';
import TailedOptions from './TailedOptions';
import { QuoteLocation } from 'api/accessexpress/schema';

const WhiteLabelHomepage = () => {
  const { brand } = useBrandContext();
  const [view, setView] = useState<'hero' | 'options'>('hero');
  const [addressValue, setAddressValue] = useState<
    QuoteLocation & { street?: string | null | undefined }
  >();

  return (
    <div
      className={clsx('relative min-h-[calc(100vh-104px)] shadow-elevation5', {
        'bg-[radial-gradient(125.68%_106.19%_at_50%_26.98%,_#0D1219_0%,_#222231_100%)]':
          !brand?.backgroundColor && brand?.mode === 'dark',
        'bg-background-base-surface-2': brand?.backgroundColor,
      })}
    >
      <AbstractBackground />
      {view === 'hero' && (
        <Hero
          onLoadingDone={() => setView('options')}
          addressValue={addressValue}
          setAddressValue={setAddressValue}
        />
      )}
      {view === 'options' && (
        <TailedOptions
          onSearchAgain={() => setView('hero')}
          addressValue={addressValue}
        />
      )}
    </div>
  );
};

export default WhiteLabelHomepage;
